<script lang="ts" setup>
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { type SupportWorkFlow } from '@providers/support/supportWorkFlow';

const { session } = defineProps<{
    session: SupportWorkFlow;
}>();

const emit = defineEmits<{
    startSession: [];
}>();

const createdDate = computed(() =>
    dayConfig.jalali(session.startedAt).format('YYYY-MM-DD')
);
</script>

<template>
    <div class="session" @click="emit('startSession')">
        <div class="session-body">
            <mr-typography weight="500" color="var(--gray-800)">
                {{ session.sessionName }}
            </mr-typography>
            <div class="session-detail">
                <mr-chips size="small">
                    <mr-typography size="x-small" weight="500">
                        {{ session.stateTitle }}
                    </mr-typography>
                </mr-chips>
                <mr-typography size="small" color="var(--gray-700)">
                    {{ createdDate }}
                </mr-typography>
            </div>
        </div>
        <mr-icon :icon="faChevronLeft" />
    </div>
</template>

<style lang="scss" scoped>
.sessions {
    display: flex;
    flex-direction: column;
    background-color: usePalette($p-cool-gray, $p-200);
    padding: 12px;
    gap: 8px;
    border-radius: 12px;
    border: 1px solid usePalette($p-cool-gray, $p-400);
    .session {
        display: flex;
        align-items: center;
        background-color: white;
        padding: 12px;
        gap: 12px;
        border-radius: 12px;
        border: 1px solid usePalette($p-gray, $p-500);
        cursor: pointer;
        .session-body {
            display: flex;
            flex-direction: column;
            gap: 12px;
            flex-grow: 1;
            .session-detail {
                display: flex;
                align-items: center;
                gap: 8px;
            }
        }
    }
}
</style>
